import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield, FiLock, FiCheckCircle } = FiIcons;

const features = [
  { title: "Cyber Defense", desc: "Stay ahead of threats with expert-driven cybersecurity compliance.", icon: FiShield },
  { title: "Privacy Made Simple", desc: "Protect customer trust with seamless data privacy management. We also offer GDPR Article 27 representation in the EU and UK.", icon: FiLock },
  { title: "Compliance Without Complexity", desc: "Effortlessly meet every regulatory framework and industry standard.", icon: FiCheckCircle },
];

export default function Features() {
  return (
    <section className="pt-24 pb-24 md:pt-32 md:pb-32 bg-[#0d0d0d] border-t border-[#222222]">
      <div className="container mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-[#1a1a1a] border border-[#2a2a2a] p-10 rounded-2xl shadow-xl hover:border-brand-orange/40 transition-all duration-300 group"
            >
              <div className="w-14 h-14 rounded-xl bg-brand-orange/10 border border-brand-orange/20 flex items-center justify-center mb-6 transform group-hover:scale-110 transition-transform duration-300">
                <SafeIcon icon={feature.icon} className="text-2xl text-brand-orange" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{feature.title}</h3>
              <p className="text-gray-400 leading-relaxed text-sm">{feature.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}